import { createStyles } from '@mantine/core'

export const useStyles = createStyles(() => ({
	notFoundPage: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		fontSize: 32,
		fontWeight: 600,
		minHeight: 300,
		textAlign: 'center',
	},
}))
